import { Box } from "@mui/material"
import React from "react"
import "./adjectifCloud.scss"
import ThemeCvDto from "../../../../../api/models/cvTheme"

interface AdjectifCloudProps {
	words: string[]
	color: string | undefined
	theme: ThemeCvDto | null
}

function AdjectifCloud({ words, color, theme }: AdjectifCloudProps) {
	const getRandomFontSize = (): number => {
		const minSize = 25
		const maxSize = 50
		return Math.floor(Math.random() * (maxSize - minSize + 1)) + minSize // Taille aléatoire
	}

	const colors = [
		theme?.adjColorText1,
		theme?.adjColorText2,
		theme?.adjColorText3,
	]

	function getRandomColor() {
		return colors[Math.floor(Math.random() * colors.length)]
	}

	function getRandomTextOutline() {
		const outlineColor = getRandomColor()
		return `
            1px 1px 0 ${outlineColor},
            -1px -1px 0 ${outlineColor},
            1px -1px 0 ${outlineColor},
            -1px 1px 0 ${outlineColor}
        `
	}

	const outlineCount = Math.floor(words.length * 0.3) // 30% des mots
	const outlineIndices = new Set<number>()

	while (outlineIndices.size < outlineCount) {
		outlineIndices.add(Math.floor(Math.random() * words.length))
	}

	return (
		<Box
			sx={{
				margin: "auto",
				display: "flex",
				flexWrap: "wrap",
				justifyContent: "center",
				padding: "20px",
				width: "80%",
				marginTop: "20%",
			}}
		>
			{words.map((word, index) => {
				const hasOutline = outlineIndices.has(index)
				const textColor = hasOutline ? color : getRandomColor()
				const textShadow = hasOutline ? getRandomTextOutline() : "none"
				const animationDelay = Math.random() * 2
				return (
					<span
						key={word}
						className="word"
						style={{
							flex: "0 0 auto",
							fontSize: `${getRandomFontSize()}px`,
							margin: `${Math.random() * 20}px ${Math.random() * 10}px`,
							fontFamily: `${theme?.fontFamily}`,
							color: textColor,
							textShadow,
							animation: `float 3s ease-in-out infinite`,
							animationDelay: `${animationDelay}s`,
						}}
					>
						{word}
					</span>
				)
			})}
		</Box>
	)
}

export default AdjectifCloud
